module.exports = __webpack_public_path__ + "img/bbc.e8f7af28.jpg";